function Unauthorized() {
  return <div className="p-4 text-center text-red-600 font-bold">403 - You are not authorized to view this page.</div>;
}
export default Unauthorized;